import { render, staticRenderFns } from "./dynamicForm.vue?vue&type=template&id=1d31cefa&scoped=true&"
import script from "./dynamicForm.vue?vue&type=script&lang=ts&"
export * from "./dynamicForm.vue?vue&type=script&lang=ts&"
import style0 from "./dynamicForm.vue?vue&type=style&index=0&id=1d31cefa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31cefa",
  null
  
)

export default component.exports